import { headerStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaHeader";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(headerStyles, {
    headerGridContainer: {
        css: css`
            margin-bottom: 50px;
        `,
    },
    buttonsGridItem: {
        css: css`
            align-items: center;

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["flex-start", null, null, "flex-end", null], properties: ["justify-content"] }],
                    mediaOptions.min,
                )}
        `,
        width: [12, 12, 12, 6, 6],
    },
    titleGridItem: {
        width: [12, 12, 12, 6, 6],
    },
    title: {
        variant: "h1",
        as: "h1",
    },
});
